// extracted by mini-css-extract-plugin
export default {"products":"ProductCategories_products__esqWM","product":"ProductCategories_product__WP7pQ","prodLink":"ProductCategories_prodLink__JLb04"};